import {Component, EventEmitter, OnDestroy, OnInit} from '@angular/core';
import {MyDialogDataModel} from '../../models/my-dialog-data.model';
import {EditModalService} from '../../services/edit-modal.service';
import {ModalVisibilityService} from '../../services/modal-visibility.service';
import {Subscription} from 'rxjs';
import {debounceTime, throttle} from 'rxjs/operators';
import {EnumUtils} from '../../utils/enum.utils';
import {IProjectService} from '../../services/project.service.interface';
import {MyPriceApprovalModeEnum} from '../../enums/my-price-approval-mode.enum';
import {PriceApprovalCommentModalComponent} from '../price-approval-comment-modal/price-approval-comment-modal.component';
import {PriceApprovalStatusEnum} from '../../enums/price-approval-status.enum';
import {ModalDialogV3} from '../../../../shared-modal-dynamic/models/modal-dialog-v3';
import {IModalDialogV3} from '../../../../shared-modal-dynamic/interfaces/i-modal-dialog-v3';

@Component({
    selector: 'app-summary-modal',
    templateUrl: './summary-modal.component.html',
    styleUrls: ['./summary-modal.component.scss']
})
export class SummaryModalComponent extends ModalDialogV3 implements OnInit, OnDestroy {

    public isInitialized = true;
    public dialogModel: MyDialogDataModel;

    private scrollEvent: EventEmitter<void> = new EventEmitter();
    private scrollStartSub: Subscription;

    // price approval mode displays approval buttons at the bottom and price fields will be highlighted with blue color
    // the buttons also allows confirm the prices
    // otherwise the project will be displayed in preview mode
    public usePriceApprovalMode = MyPriceApprovalModeEnum.DISABLED;


    constructor(public editModalService: EditModalService,
                private modalVisibilityService: ModalVisibilityService,
                private projectService: IProjectService,
    ) {
        super();
    }

    public async ngOnInit() {
        this.isInitialized = false;
        try {

            const project = this.modalParams.model['project'];
            if (project) {
                await this.editModalService.init(project);
            } else {
                console.warn('project was not found in modalParams, dialog will not be opened');
                this.close();
            }


            this.dialogModel = this.editModalService.getDialogModel();

            this.editModalService.isDialogOpened = true;

            this.scrollStartSub = this.scrollEvent.pipe(
                // to emit new scrollStart event the scroll events must be paused at least for 300ms
                throttle(ev => this.scrollEvent.pipe(debounceTime(300)))
            ).subscribe(x => this.modalVisibilityService.announceCloseEditDialogModalsRequest('summary_modal_ngOnInit'));
        } catch (e) {
            console.error(e);
            this.close();
        }

        this.isInitialized = true;
    }

    public onModalClicked() {
        this.modalVisibilityService.announceCloseEditDialogModalsRequest('summary-modal');
    }

    public onCancelBtnClicked() {
        this.close();
    }

    // public onTopSubmitBtnClicked() {
    //     // this.editModalService.collectProjectRequestedInfosForRest();
    //     this.announceModelChanged(
    //         {
    //             msg: 'save data',
    //             project: this.dialogModel.project
    //         });
    // }

    public close() {
        this.editModalService.isDialogOpened = false;
        this.modalVisibilityService.announceCloseEditDialogModalsRequest('summary-modal close');
        super.close();
    }

    public onScroll() {
        this.scrollEvent.next();
    }

    public onPriceDenyBtnClicked() {

        const priceApprovalCommentModalRef = this.modalDynamicV3Service
            .open(PriceApprovalCommentModalComponent, {
                model: {
                    mode: PriceApprovalStatusEnum.PRICES_REJECTED
                }
            });

        priceApprovalCommentModalRef.subscribe(async (val) => {
            // console.log('handlePriceApprovalCommentModalResult', val);

            await this.handlePriceApprovalCommentModalResult(
                PriceApprovalStatusEnum.PRICES_REJECTED,
                val['comment'],
                priceApprovalCommentModalRef
            );
        });

    }

    public onPriceConfirmBtnClicked() {

        const priceApprovalCommentModalRef = this.modalDynamicV3Service
            .open(PriceApprovalCommentModalComponent, {
                model: {
                    mode: PriceApprovalStatusEnum.PRICES_APPROVED
                }
            });

        priceApprovalCommentModalRef.subscribe(async (val) => {
            // console.log('handlePriceApprovalCommentModalResult', val);
            await this.handlePriceApprovalCommentModalResult(
                PriceApprovalStatusEnum.PRICES_APPROVED,
                val['comment'],
                priceApprovalCommentModalRef
            );
        });

    }

    private async handlePriceApprovalCommentModalResult(
        priceApprovalStatusDetail: PriceApprovalStatusEnum,
        priceApprovalComment: string,
        priceApprovalCommentModalRef: IModalDialogV3
    ) {
        try {
            if (priceApprovalStatusDetail !== undefined) {

                await this.projectService.updateProjectStatusDetail(
                    this.dialogModel.project.id,
                    EnumUtils.getKeyByValue(PriceApprovalStatusEnum, priceApprovalStatusDetail),
                    priceApprovalComment
                );
            }

            priceApprovalCommentModalRef.close();

            this.announceModelChanged(undefined);  // because of this, the project list will be reloaded
            this.close();

        } catch (e) {
            console.error(e);
        }
    }

    public isActivePriceApprovalMode() {
        return this.usePriceApprovalMode === MyPriceApprovalModeEnum.ACTIVE;
    }

    public isDisabledPriceApprovalMode() {
        return this.usePriceApprovalMode === MyPriceApprovalModeEnum.DISABLED;
    }

    ngOnDestroy(): void {
        if (this.scrollStartSub) {
            this.scrollStartSub.unsubscribe();
        }
    }
}
